export default __webpack_public_path__ + "static/media/gallery_04.18a1c2c6.jpg";